const BriefTitle = () => {
  return (
    <>
      <h3 className="text-4xl font-medium text-base-700 font-relais pb-3">
        Brief
      </h3>
      <p className="text-base text-base-700 mb-6">
        Input a short description and Jacquard will generate an optimised brief.
      </p>
    </>
  )
}

export default BriefTitle
